import {
  AccordionButton,
  useAccordionContext,
  useAccordionItemContext,
} from '@reach/accordion';
import cx from 'clsx';
import React, { memo } from 'react';

import { MinusIcon, PlusIcon } from '@/components/icons';
import styles from '@/components/SideNavigation/MainNavigation/MainNavigation.module.scss';
import { isEqual } from '@/utils/lodash-alternatives';

interface AnimatedAccordionButtonProps {
  isActive?: boolean;
  hideExpandButton: boolean;
}

const AnimatedAccordionButton: React.FC<AnimatedAccordionButtonProps> = memo(
  ({ isActive, hideExpandButton }) => {
    const { isExpanded } = useAccordionItemContext();
    const { openPanels } = useAccordionContext();
    const loadingAnimation = isExpanded && openPanels.length > 0;

    return (
      <AccordionButton
        className={cx(styles.accordionButton, styles.accordionButtonIcon)}
      >
        {!hideExpandButton ? (
          <>
            <MinusIcon
              className={cx(
                styles.accordionIcon,
                isActive && styles.accordionIconActive,
                loadingAnimation ? styles.expandMinus : styles.hideMinus
              )}
            />
            <PlusIcon
              className={cx(
                styles.accordionIcon,
                isActive && styles.accordionIconActive,
                loadingAnimation ? styles.collapsePlus : styles.showPlus
              )}
            />
          </>
        ) : null}
      </AccordionButton>
    );
  },
  (
    prevProps: AnimatedAccordionButtonProps,
    nextProps: AnimatedAccordionButtonProps
  ) => isEqual(prevProps, nextProps)
);

export default AnimatedAccordionButton;
